// Static marketing content for Aureon Estates frontend.

export const BRAND = {
  name: "Aureon Estates",
  short: "Aureon",
  tagline: "Where Vision Rises Into Landmark Living",
  phone: "+91 XXXXX XXXXX",
  whatsapp: "919820000000",
  email: "celestialmindcreations@gmail.com",
  address: "Coming Soon",
  mapQuery: "Bandra Kurla Complex, Mumbai, India",
  rera: "MahaRERA P51900001234",
  established: 2000,
};

export const IMAGES = {
  blueprint: "https://images.unsplash.com/photo-1721244654392-9c912a6eb236?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  frame: "https://images.unsplash.com/photo-1565843122968-1ce0e44e865f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  day: "https://images.unsplash.com/photo-1721815693498-cc28507c0ba2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  night: "https://images.unsplash.com/photo-1601881403737-2a6085443ba2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  tower1: "https://images.pexels.com/photos/17197985/pexels-photo-17197985.jpeg?auto=compress&cs=tinysrgb&w=1600",
  tower2: "https://images.unsplash.com/photo-1778166166366-26a67894fa9f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  tower3: "https://images.unsplash.com/photo-1623051786509-57224cdc43e1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  living: "https://images.pexels.com/photos/6585598/pexels-photo-6585598.jpeg?auto=compress&cs=tinysrgb&w=1600",
  interior2: "https://images.unsplash.com/photo-1666282167632-c613fbeb163c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  interior3: "https://images.pexels.com/photos/7587828/pexels-photo-7587828.jpeg?auto=compress&cs=tinysrgb&w=1600",
  pool: "https://images.unsplash.com/photo-1571902943202-507ec2618e8f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  gym: "https://images.unsplash.com/photo-1534438327276-14e5300c3a48?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  lobby: "https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  bedroom: "https://images.unsplash.com/photo-1631049307264-da0ec9d70304?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  kitchen: "https://images.unsplash.com/photo-1556909212-d5b604d0c90d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  aerial: "https://images.unsplash.com/photo-1449844908441-8829872d2607?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  lounge: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  garden: "https://images.unsplash.com/photo-1585320806297-9794b3e4eeae?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  construction1: "https://images.unsplash.com/photo-1541888946425-d81bb19240f5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  construction2: "https://images.unsplash.com/photo-1503387762-592deb58ef4e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  villa: "https://images.unsplash.com/photo-1613490493576-7fde63acd811?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  penthouse: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
};

export const STATS = [
  { value: 25, suffix: "+", label: "Years of Legacy" },
  { value: 12, suffix: "", label: "Completed Projects" },
  { value: 5, suffix: "", label: "Ongoing Developments" },
  { value: 10000, suffix: "+", label: "Happy Residents" },
];

export const MILESTONES = ["Vision", "Design", "Construction", "Craftsmanship", "Completion"];

export const WHY_US = [
  { icon: "MapPinLine", title: "Prime Locations", text: "Addresses chosen for enduring value, connectivity and outlook." },
  { icon: "Medal", title: "Superior Quality", text: "Uncompromising specifications and internationally benchmarked finishes." },
  { icon: "Clock", title: "On-Time Delivery", text: "A 25-year record of handing over homes when promised." },
  { icon: "Sparkle", title: "Modern Amenities", text: "Resort-grade wellness, leisure and community spaces." },
  { icon: "Handshake", title: "Transparent Process", text: "RERA-compliant, clear titles and honest documentation." },
  { icon: "TrendUp", title: "Value Appreciation", text: "Master-planned communities that grow in worth over time." },
];

export const AMENITIES = [
  { name: "Infinity Sky Lounge", icon: "Martini", image: "lounge", span: "lg", text: "A rooftop lounge suspended above the skyline." },
  { name: "Temperature-Controlled Pool", icon: "Waves", image: "pool", span: "md", text: "Swim year-round in a resort-grade pool deck." },
  { name: "Signature Clubhouse", icon: "Buildings", image: "lobby", span: "md", text: "A grand social heart for the community." },
  { name: "State-of-the-Art Gym", icon: "Barbell", image: "gym", span: "md", text: "Fully equipped wellness and fitness studio." },
  { name: "Landscaped Gardens", icon: "Tree", image: "garden", span: "md", text: "Curated greens, water bodies and quiet corners." },
  { name: "Kids Play Zone", icon: "Baby", image: "garden", span: "sm", text: "Safe, imaginative play areas for little ones." },
  { name: "Jogging Track", icon: "PersonSimpleRun", image: "aerial", span: "sm", text: "A shaded loop for morning runs." },
  { name: "24x7 Security", icon: "ShieldCheck", image: "lobby", span: "sm", text: "Multi-tier surveillance and access control." },
];

export const FLOOR_TABS = [
  { key: "2bhk", label: "2 BHK", area: "1,180 sq.ft", price: "₹ 3.1 Cr onwards", image: "blueprint", points: ["Efficient carpet-to-built ratio", "Sunlit living & dining", "Utility + dry balcony"] },
  { key: "3bhk", label: "3 BHK", area: "1,740 sq.ft", price: "₹ 4.0 Cr onwards", image: "frame", points: ["Private master suite", "Wide sundeck", "Guest powder room"] },
  { key: "penthouse", label: "Penthouse", area: "3,950 sq.ft", price: "₹ 7.4 Cr onwards", image: "penthouse", points: ["Double-height living", "Private plunge pool", "Panoramic terrace"] },
  { key: "commercial", label: "Commercial", area: "850 sq.ft", price: "On request", image: "day", points: ["Grade-A office suites", "High-street retail", "Ample parking"] },
];

export const TESTIMONIALS = [
  { name: "Rohan & Meera Kapoor", role: "Homeowners, Aureon Vantage", rating: 5, quote: "From the first site visit to handover, Aureon set a standard we didn't know to expect. The finish quality is genuinely world-class." },
  { name: "Aditi Rao", role: "Investor", rating: 5, quote: "I've invested across three Aureon projects. On-time delivery and steady appreciation — they simply keep their word." },
  { name: "Vikram Shetty", role: "Channel Partner", rating: 5, quote: "Selling Aureon is effortless. The brand, the transparency and the customer experience do most of the work for us." },
  { name: "The Menon Family", role: "Residents, Serene Heights", rating: 5, quote: "It feels less like an apartment and more like a private resort we come home to every evening." },
];

export const VALUES = [
  { title: "Craftsmanship", text: "We treat every detail as visible, because eventually it is." },
  { title: "Integrity", text: "Transparent dealings and clean titles, without exception." },
  { title: "Vision", text: "We build landmarks meant to age with grace." },
  { title: "Stewardship", text: "Sustainable, community-first master planning." },
];

export const COMPANY_TIMELINE = [
  { year: "2000", title: "Founded in Mumbai", text: "Aureon Estates is established with a single boutique residential project." },
  { year: "2008", title: "First Landmark Tower", text: "Delivered our first high-rise, setting a new local benchmark for finishes." },
  { year: "2014", title: "Multi-City Expansion", text: "Entered Bangalore and Pune with award-winning developments." },
  { year: "2020", title: "10,000 Residents", text: "Crossed ten thousand happy families across our communities." },
  { year: "2025", title: "The Skyline Era", text: "Launched our most ambitious sea-facing and villa collections yet." },
];

export const AWARDS = [
  "Realty+ Developer of the Year 2024",
  "CNBC Best Luxury Project 2023",
  "IGBC Platinum Green Rating",
  "Times Real Estate Icon 2022",
];

export const LEADERSHIP = {
  name: "Arjun Aureon",
  role: "Founder & Managing Director",
  quote: "We do not build the tallest towers. We build the ones people are proud to call home for generations. Every slab we pour is a promise about how someone will live.",
};

export const FAQS = [
  { q: "Is Aureon Estates RERA registered?", a: "Yes. Every Aureon project is registered under the applicable state RERA, and registration numbers are published on each project page and all marketing collateral." },
  { q: "Do you offer home loan assistance?", a: "All our projects are pre-approved by leading banks and NBFCs. Our relationship team assists you end-to-end with documentation and disbursal." },
  { q: "Can I book a site visit before deciding?", a: "Absolutely. We encourage a chauffeured site visit and a walkthrough of our sample residences. Book via any enquiry form on the site." },
  { q: "What after-sales support do you provide?", a: "A dedicated relationship manager, a defect-liability warranty, and a resident app for service requests and community updates." },
  { q: "Are the projects suitable for investment?", a: "Yes. Our master-planned, amenity-rich communities in prime micro-markets have historically shown strong rental demand and capital appreciation." },
  { q: "How do channel partners register?", a: "Visit our Channel Partner page and submit the partnership form. Our team activates your account and shares live inventory and commission structures." },
];

export const CONTACT_TIMES = ["Morning (9AM–12PM)", "Afternoon (12PM–4PM)", "Evening (4PM–8PM)", "Anytime"];
export const BUDGETS = ["₹ 1–2 Cr", "₹ 2–4 Cr", "₹ 4–7 Cr", "₹ 7 Cr+"];
export const BLOG_CATEGORIES = ["All", "Real Estate Trends", "Investment Guides", "Home Buying Tips", "Construction Updates", "Developer News", "Design & Lifestyle"];
export const GALLERY_CATEGORIES = ["All", "Exterior", "Interior", "Amenities", "Construction", "Night Views", "Aerial"];

export const PARTNER_BENEFITS = [
  { icon: "Percent", title: "Industry-Leading Commissions", text: "Transparent, tiered payouts released on a predictable schedule." },
  { icon: "Lightning", title: "Live Inventory Access", text: "Real-time unit availability and instant booking confirmations." },
  { icon: "Headset", title: "Dedicated Partner Desk", text: "A relationship manager and marketing kit for every partner." },
  { icon: "ChartLineUp", title: "Investor Opportunities", text: "Pre-launch allocations and curated investment structures." },
];
